import { WidgetData } from 'src/store/actions/widget';
import { useAppSelector } from 'universal-scripts';

export const useClientConfig = (): WidgetData | null => {
	return useAppSelector((s) => s.widget as WidgetData | null);
};
